var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _vm._v(" " + _vm._s(_vm.editFormTitle) + " "),
          _c("v-spacer"),
          _c(
            "v-btn",
            { attrs: { icon: "" }, on: { click: _vm.close } },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            { staticClass: "flex-column" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          label: "Код скважины",
                        },
                        model: {
                          value: _vm.editedItem.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.editedItem, "id", $$v)
                          },
                          expression: "editedItem.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.types,
                          dense: "",
                          "hide-details": "",
                          label: "Тип скважины",
                        },
                        model: {
                          value: _vm.editedItem.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.editedItem, "type", $$v)
                          },
                          expression: "editedItem.type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "number",
                          dense: "",
                          "hide-details": "",
                          label: "Глубина",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_vm._v("м")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.depth,
                          callback: function ($$v) {
                            _vm.$set(_vm.editedItem, "depth", $$v)
                          },
                          expression: "editedItem.depth",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "number",
                          dense: "",
                          "hide-details": "",
                          label: "Глубина забоя",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_vm._v("м")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.bottomhole_depth,
                          callback: function ($$v) {
                            _vm.$set(_vm.editedItem, "bottomhole_depth", $$v)
                          },
                          expression: "editedItem.bottomhole_depth",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          min: "0",
                          max: _vm.reservoir.grids_x * _vm.reservoir.dx,
                          dense: "",
                          "hide-details": "",
                          type: "number",
                          label: "X",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_vm._v("м")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.x_coord,
                          callback: function ($$v) {
                            _vm.$set(_vm.editedItem, "x_coord", _vm._n($$v))
                          },
                          expression: "editedItem.x_coord",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          min: "0",
                          max: _vm.reservoir.grids_y * _vm.reservoir.dy,
                          dense: "",
                          "hide-details": "",
                          type: "number",
                          label: "Y",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_vm._v("м")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.y_coord,
                          callback: function ($$v) {
                            _vm.$set(_vm.editedItem, "y_coord", _vm._n($$v))
                          },
                          expression: "editedItem.y_coord",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          min: "0",
                          max: _vm.reservoir.grids_z * _vm.reservoir.dz,
                          dense: "",
                          "hide-details": "",
                          type: "number",
                          label: "Z (относительная)",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_vm._v("м")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.z_coord_relative,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editedItem,
                              "z_coord_relative",
                              _vm._n($$v)
                            )
                          },
                          expression: "editedItem.z_coord_relative",
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.editedItem ? _vm.editedItem.z_coord : "") +
                          " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          min: "0",
                          dense: "",
                          "hide-details": "",
                          type: "number",
                          label: "k",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_vm._v("мД")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.k_well_permeability,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editedItem,
                              "k_well_permeability",
                              _vm._n($$v)
                            )
                          },
                          expression: "editedItem.k_well_permeability",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          min: "0",
                          dense: "",
                          "hide-details": "",
                          type: "number",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [_vm._v("φ")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.phi_well_porosity,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editedItem,
                              "phi_well_porosity",
                              _vm._n($$v)
                            )
                          },
                          expression: "editedItem.phi_well_porosity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          min: "0",
                          max: "1",
                          step: "0.1",
                          dense: "",
                          "hide-details": "",
                          type: "number",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [_vm._v("S"), _c("sub", [_vm._v("w")])]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.sw_water_saturation,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editedItem,
                              "sw_water_saturation",
                              _vm._n($$v)
                            )
                          },
                          expression: "editedItem.sw_water_saturation",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          min: "0",
                          dense: "",
                          "hide-details": "",
                          type: "number",
                          label: "p",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_vm._v("бар")]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.p_pressure,
                          callback: function ($$v) {
                            _vm.$set(_vm.editedItem, "p_pressure", _vm._n($$v))
                          },
                          expression: "editedItem.p_pressure",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          type: "number",
                          label: "Начальный дебит, q",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [_c("nobr", [_vm._v("м3/д")])]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.editedItem.q_initial_rate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editedItem,
                              "q_initial_rate",
                              _vm._n($$v)
                            )
                          },
                          expression: "editedItem.q_initial_rate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-title",
                            [
                              _vm._v(" Перфорации "),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "primary", elevation: "0" },
                                  on: { click: _vm.joinNodes },
                                },
                                [_vm._v("Объединить")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", elevation: "0" },
                                  on: { click: _vm.addNode },
                                },
                                [_vm._v("Добавить")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panels",
                            _vm._l(_vm.editedItem.nodes, function (node, i) {
                              return _c(
                                "v-expansion-panel",
                                { key: i },
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v("Перфорация #" + _vm._s(i + 1)),
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c("node-edit", {
                                        attrs: { reservoir: _vm.reservoir },
                                        model: {
                                          value: _vm.editedItem.nodes[i],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem.nodes,
                                              i,
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.nodes[i]",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          value: _vm.getConnectionsValue(_vm.editedItem),
                          items: _vm.getAllConnections(_vm.editedItem),
                          label: "Соединения",
                          multiple: "",
                          chips: "",
                          "deletable-chips": "",
                        },
                        on: { input: _vm.setConnections },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            {
              attrs: { color: "danger", outlined: "", small: "" },
              on: { click: _vm.deleteWell },
            },
            [_vm._v("Удалить")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "secondary", outlined: "", small: "" },
              on: { click: _vm.recalcWell },
            },
            [_vm._v("Пересчитать")]
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", elevation: "0" },
              on: { click: _vm.save },
            },
            [_vm._v("Сохранить")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }